'use client';

import { useEffect } from 'react';
import { setupGlobalAxiosErrorHandler } from '@/app/utils/setupGlobalAxiosErrorHandler';
import { setupChunkLoadRecovery } from '@/app/utils/chunkLoadRecovery';

export default function GlobalErrorHandlerInit() {
  useEffect(() => {
    setupGlobalAxiosErrorHandler();
    return setupChunkLoadRecovery();
  }, []);

  return null;
}
